import { render } from "./PortalApp.vue?vue&type=template&id=90bd4cd0&ts=true"
import script from "./PortalApp.vue?vue&type=script&lang=ts"
export * from "./PortalApp.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2728993903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__